import { Component, Input } from "@angular/core";
import { Dialog, SharedModule } from "@bb-vendure/admin-ui/core";

export type B2BExportFormat = "xlsx" | "pdf";

export interface B2BExportDialogResult {
  format: B2BExportFormat;
}

@Component({
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./export-b2b-invoice-dialog.component.html",
})
export default class ExportB2BInvoiceDialog
  implements Dialog<B2BExportDialogResult>
{
  @Input() total: number;

  format: B2BExportFormat = "xlsx";

  resolveWith: (result?: B2BExportDialogResult) => void;

  setFormat(value: B2BExportFormat) {
    this.format = value;
  }

  cancel() {
    this.resolveWith();
  }

  save() {
    this.resolveWith({ format: this.format });
  }
}
